import { NestedAppAuthenticator, NestedAppAuthenticatorOptions } from '../nestedAppAuth';

/* 
This authenticator extends the NestedAppAuthenticator.
*/
export default class TeamsAuthenticatorV2 extends NestedAppAuthenticator {
  constructor(options: NestedAppAuthenticatorOptions) {
    super(options);
  }

  public getToken = (resource: string, claims?: string, tenantId?: string): Promise<string> =>
    super.getToken(resource, claims, tenantId);
}
